import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import "./FlightQuotePrint.scss";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getFlightQuotationByID } from "../services/quotation.services";
import moment from "moment";
import { calculateDuration, formatIndianNumber } from "../../../_helper/helper";
import { IoIosMail } from "react-icons/io";
import IconComponent from "../../../components/common/IconComponent";
import { MdCall, MdOutgoingMail, MdPrint } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { TbWorldWww } from "react-icons/tb";
import { FcSurvey } from "react-icons/fc";
import { FaFilePdf } from "react-icons/fa";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { getLocalAccessToken } from "../../../app/getTokens";
import { API_URL } from "../../../app/config";
import { LoadingPanel } from "../../../components/layout/Loading";
import { axiosApiInstance } from "../../../app/axios";
import NoDataFoundPage from "../../../components/common/NoDataFoundPage";

const FlightQuotePrint: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const FlightQuot_GUID = params?.FlightQuot_GUID;
  const loading = useAppSelector((state) => state.quotation.loading);
  const FlightQuotationDetail = useAppSelector(
    (state) => state.quotation.FlightQuotationDetail,
  );
  const [emailLoading, setEmailLoading] = useState(false);
  const [PDFLoading, setPDFLoading] = useState(false);

  // const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    if (FlightQuot_GUID) {
      dispatch(getFlightQuotationByID({ FlightQuot_GUID: FlightQuot_GUID }));
    }
  }, [FlightQuot_GUID]);

  // useEffect(() => {
  //   const now = new Date();
  //   setCurrentDate(
  //     now.toLocaleDateString("en-IN", {
  //       year: "numeric",
  //       month: "long",
  //       day: "numeric",
  //     })
  //   );
  // }, []);

  const handleSendEmail = async (FlightQuot_GUID: string) => {
    try {
      setEmailLoading(true);
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightQuotation/DynamicGetFlightQuotationPDF`,
        { FlightQuot_GUID: FlightQuot_GUID },
      );
      if (response.status === 200) {
        SuccessToast("Email Sent Successfully!");
      } else {
        ErrorToast("Failed to Send Email!");
      }
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to sending Quotation! - Please try again later");
    } finally {
      setEmailLoading(false);
    }
  };

  const handleQuotationDownload = async (FlightQuot_GUID: string) => {
    const token = getLocalAccessToken();
    try {
      setPDFLoading(true);

      const response = await fetch(
        `${API_URL}/FlightQuotation/DynamicDownloadGetFlightQuotationPDF`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            FlightQuot_GUID: FlightQuot_GUID,
          }),
        },
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Flight Processing Quotation.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Quotation! - Please try again later");
    } finally {
      setPDFLoading(false);
    }
  };
  if (loading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      {(emailLoading || PDFLoading) && <LoadingPanel gridRef={gridRef} />}
      {FlightQuotationDetail?.ID ? (
        <div className="flight-quote-print-container">
          <div className="header">
            <div className="company-info">
              <div className="logo-section">
                {FlightQuotationDetail?.CompanyDetails &&
                  FlightQuotationDetail?.CompanyDetails?.CompanyLogo && (
                    <img
                      src={
                        FlightQuotationDetail?.CompanyDetails &&
                        FlightQuotationDetail?.CompanyDetails?.CompanyLogo
                          ? FlightQuotationDetail?.CompanyDetails?.CompanyLogo
                          : ""
                      }
                      alt="Company Logo"
                      className="company-logo"
                    />
                  )}
                <h1>
                  {FlightQuotationDetail?.CompanyDetails &&
                  FlightQuotationDetail?.CompanyDetails?.CompanyName
                    ? FlightQuotationDetail?.CompanyDetails?.CompanyName
                    : "AICRM Travel"}
                </h1>
                {/* <p>Your Trusted Flight Booking Partner</p> */}
              </div>
              <div className="contact-info">
                {FlightQuotationDetail?.CompanyDetails?.EmailID && (
                  <div>
                    <IconComponent icon={IoIosMail} />{" "}
                    {FlightQuotationDetail?.CompanyDetails?.EmailID}
                  </div>
                )}
                {FlightQuotationDetail?.CompanyDetails?.MobileNo && (
                  <div>
                    <IconComponent icon={MdCall} style={{ color: "red" }} />{" "}
                    {FlightQuotationDetail?.CompanyDetails?.MobileNo}
                  </div>
                )}
                <div>
                  <IconComponent
                    icon={TbWorldWww}
                    style={{ color: "#20c4f3" }}
                  />{" "}
                  www.aicrmtravel.com
                </div>
                {FlightQuotationDetail?.CompanyDetails?.Address && (
                  <div>
                    <IconComponent
                      icon={FaLocationDot}
                      style={{ color: "red" }}
                    />{" "}
                    {FlightQuotationDetail?.CompanyDetails?.Address}
                  </div>
                )}
                {FlightQuotationDetail?.CompanyDetails?.GSTNo && (
                  <div>
                    GSTIN: {FlightQuotationDetail?.CompanyDetails?.GSTNo}
                  </div>
                )}
              </div>
            </div>
            <div className="quote-title">FLIGHT BOOKING QUOTE</div>
          </div>

          <div className="content">
            {/* <div className="quote-selector">
          {FlightQuotationDetail?.TripType === "One Way" ? (
            <button className={`quote-type-btn`}>✈️ One Way</button>
          ) : (
            <button className={`quote-type-btn`}>🔄 Round Trip</button>
          )}
        </div> */}
            <div className={`quote-content`}>
              <div className="quote-details">
                <div className="detail-section">
                  <h3>Passenger Information</h3>
                  <div className="detail-item">
                    <span className="detail-label">Quote ID:</span>
                    <span className="detail-value">
                      {FlightQuotationDetail?.FlightQuotationNo}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Passenger Name:</span>
                    <span className="detail-value">
                      {FlightQuotationDetail?.Initial}{" "}
                      {FlightQuotationDetail?.FirstName}{" "}
                      {FlightQuotationDetail?.LastName}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Email:</span>
                    <span className="detail-value">
                      {FlightQuotationDetail.EmailID}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Phone:</span>
                    <span className="detail-value">
                      {FlightQuotationDetail.MobileNo}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Passengers:</span>
                    <span className="detail-value">
                      {+(FlightQuotationDetail?.TotalDeparturePax || 0)}
                    </span>
                  </div>
                </div>

                <div className="detail-section">
                  <h3>Booking Details</h3>
                  <div className="detail-item">
                    <span className="detail-label">Trip Type:</span>
                    <span className="detail-value">
                      {FlightQuotationDetail?.TripType}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Class:</span>
                    <span className="detail-value">
                      {FlightQuotationDetail?.FlightClass}
                    </span>
                  </div>
                  {FlightQuotationDetail?.DepartureDate && (
                    <div className="detail-item">
                      <span className="detail-label">Departure Date:</span>
                      <span className="detail-value">
                        {FlightQuotationDetail?.DepartureDate
                          ? moment(FlightQuotationDetail?.DepartureDate).format(
                              "DD/MM/YYYY",
                            )
                          : ""}
                      </span>
                    </div>
                  )}
                  {FlightQuotationDetail?.ReturnDepartureDate && (
                    <div className="detail-item">
                      <span className="detail-label">Return Date:</span>
                      <span className="detail-value">
                        {" "}
                        {FlightQuotationDetail?.ReturnDepartureDate
                          ? moment(
                              FlightQuotationDetail?.ReturnDepartureDate,
                            ).format("DD/MM/YYYY")
                          : ""}
                      </span>
                    </div>
                  )}
                  <div className="detail-item">
                    <span className="detail-label">Quote Valid Until:</span>
                    <span className="detail-value">
                      {" "}
                      {FlightQuotationDetail?.ValidUntil
                        ? moment(FlightQuotationDetail?.ValidUntil).format(
                            "DD/MM/YYYY",
                          )
                        : ""}
                    </span>
                  </div>
                  {/* {oneWayQuote.status && (
                <div className="detail-item">
                  <span className="detail-label">Booking Status:</span>
                  <span className="detail-value">{oneWayQuote.status}</span>
                </div>
              )} */}
                </div>
              </div>

              {FlightQuotationDetail?.FlightScope === 2 ? (
                <>
                  <div className="flight-details">
                    <div className="flight-segment">
                      <div className="flight-header">
                        <div className="flight-route">
                          {FlightQuotationDetail?.FromAirportName}
                          {FlightQuotationDetail?.FromAirportCode
                            ? ` (${FlightQuotationDetail?.FromAirportCode})`
                            : ""}{" "}
                          → {FlightQuotationDetail?.ToAirportName}
                          {FlightQuotationDetail?.ToAirportCode
                            ? ` (${FlightQuotationDetail?.ToAirportCode})`
                            : ""}
                        </div>
                        {FlightQuotationDetail?.TripType === "Two Way" && (
                          <div className="flight-type">Outbound</div>
                        )}
                      </div>
                      <div className="flight-info">
                        <div className="detail-item">
                          <span className="detail-label">Airline:</span>
                          <span className="detail-value">
                            {" "}
                            {FlightQuotationDetail?.AirlineName}
                            {FlightQuotationDetail?.AirlineCode
                              ? ` (${FlightQuotationDetail?.AirlineCode})`
                              : ""}
                          </span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Departure:</span>
                          <span className="detail-value">
                            {" "}
                            {FlightQuotationDetail?.DepartureDate
                              ? moment(
                                  FlightQuotationDetail?.DepartureDate,
                                ).format("DD/MM/YYYY")
                              : ""}{" "}
                            {FlightQuotationDetail?.DepartureTime
                              ? moment(
                                  FlightQuotationDetail?.DepartureTime,
                                ).format("HH:mm")
                              : ""}
                          </span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Arrival:</span>
                          <span className="detail-value">
                            {" "}
                            {FlightQuotationDetail?.ArrivalDate
                              ? moment(
                                  FlightQuotationDetail?.ArrivalDate,
                                ).format("DD/MM/YYYY")
                              : ""}{" "}
                            {FlightQuotationDetail?.ArrivalTime
                              ? moment(
                                  FlightQuotationDetail?.ArrivalTime,
                                ).format("HH:mm")
                              : ""}
                          </span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Duration:</span>
                          <span className="detail-value">
                            {" "}
                            {calculateDuration(
                              FlightQuotationDetail?.DepartureDate
                                ? moment(
                                    FlightQuotationDetail?.DepartureDate,
                                  ).format("YYYY-MM-DD")
                                : "",
                              FlightQuotationDetail?.DepartureTime
                                ? moment(
                                    FlightQuotationDetail?.DepartureTime,
                                  ).format("HH:mm")
                                : "",
                              FlightQuotationDetail?.ArrivalDate
                                ? moment(
                                    FlightQuotationDetail?.ArrivalDate,
                                  ).format("YYYY-MM-DD")
                                : "",
                              FlightQuotationDetail?.ArrivalTime
                                ? moment(
                                    FlightQuotationDetail?.ArrivalTime,
                                  ).format("HH:mm")
                                : "",
                            )}
                          </span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">No. Of Stops:</span>
                          <span className="detail-value">
                            {" "}
                            {FlightQuotationDetail?.Stops
                              ? FlightQuotationDetail?.Stops === "0"
                                ? "Non Stop"
                                : FlightQuotationDetail?.Stops
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    {FlightQuotationDetail?.TripType === "Two Way" && (
                      <div className="flight-segment">
                        <div className="flight-header">
                          <div className="flight-route">
                            {FlightQuotationDetail?.ReturnFromAirportName}
                            {FlightQuotationDetail?.ReturnFromAirportCode
                              ? ` (${FlightQuotationDetail?.ReturnFromAirportCode})`
                              : ""}{" "}
                            → {FlightQuotationDetail?.ReturnToAirportName}
                            {FlightQuotationDetail?.ReturnToAirportCode
                              ? ` (${FlightQuotationDetail?.ReturnToAirportCode})`
                              : ""}
                          </div>
                          <div className="flight-type">Return</div>
                        </div>
                        <div className="flight-info">
                          <div className="detail-item">
                            <span className="detail-label">Airline:</span>
                            <span className="detail-value">
                              {" "}
                              {FlightQuotationDetail?.ReturnAirlineName}
                              {FlightQuotationDetail?.ReturnAirlineCode
                                ? ` (${FlightQuotationDetail?.ReturnAirlineCode})`
                                : ""}
                            </span>
                          </div>
                          <div className="detail-item">
                            <span className="detail-label">Departure:</span>
                            <span className="detail-value">
                              {" "}
                              {FlightQuotationDetail?.ReturnDepartureDate
                                ? moment(
                                    FlightQuotationDetail?.ReturnDepartureDate,
                                  ).format("DD/MM/YYYY")
                                : ""}{" "}
                              {FlightQuotationDetail?.ReturnDepartureTime
                                ? moment(
                                    FlightQuotationDetail?.ReturnDepartureTime,
                                  ).format("HH:mm")
                                : ""}
                            </span>
                          </div>
                          <div className="detail-item">
                            <span className="detail-label">Arrival:</span>
                            <span className="detail-value">
                              {" "}
                              {FlightQuotationDetail?.ReturnArrivalDate
                                ? moment(
                                    FlightQuotationDetail?.ReturnArrivalDate,
                                  ).format("DD/MM/YYYY")
                                : ""}{" "}
                              {FlightQuotationDetail?.ReturnArrivalTime
                                ? moment(
                                    FlightQuotationDetail?.ReturnArrivalTime,
                                  ).format("HH:mm")
                                : ""}
                            </span>
                          </div>
                          <div className="detail-item">
                            <span className="detail-label">Duration:</span>
                            <span className="detail-value">
                              {" "}
                              {calculateDuration(
                                FlightQuotationDetail?.ReturnDepartureDate
                                  ? moment(
                                      FlightQuotationDetail?.ReturnDepartureDate,
                                    ).format("YYYY-MM-DD")
                                  : "",
                                FlightQuotationDetail?.ReturnDepartureTime
                                  ? moment(
                                      FlightQuotationDetail?.ReturnDepartureTime,
                                    ).format("HH:mm")
                                  : "",
                                FlightQuotationDetail?.ReturnArrivalDate
                                  ? moment(
                                      FlightQuotationDetail?.ReturnArrivalDate,
                                    ).format("YYYY-MM-DD")
                                  : "",
                                FlightQuotationDetail?.ReturnArrivalTime
                                  ? moment(
                                      FlightQuotationDetail?.ReturnArrivalTime,
                                    ).format("HH:mm")
                                  : "",
                              )}
                            </span>
                          </div>
                          <div className="detail-item">
                            <span className="detail-label">No. Of Stops:</span>
                            <span className="detail-value">
                              {" "}
                              {FlightQuotationDetail?.ReturnStops
                                ? FlightQuotationDetail?.ReturnStops === "0"
                                  ? "Non Stop"
                                  : FlightQuotationDetail?.ReturnStops
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <table className="services-table">
                    <thead>
                      <tr>
                        <th>Service Description</th>
                        <th>Passengers</th>
                        {/* <th>Unit Price (₹)</th> */}
                        <th>Total (₹)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          Base Fare ({FlightQuotationDetail?.FromAirportCode} →{" "}
                          {FlightQuotationDetail?.ToAirportCode})
                        </td>
                        <td>
                          <div className="d-flex gap-2 justify-content-between">
                            <div>
                              {FlightQuotationDetail?.TotalDeparturePax}
                            </div>
                            <div className="d-flex gap-1">
                              <div>
                                A - {FlightQuotationDetail?.DepartureAdult || 0}
                              </div>{" "}
                              |
                              <div>
                                C - {FlightQuotationDetail?.DepartureChild || 0}
                              </div>{" "}
                              |
                              <div>
                                I -{" "}
                                {FlightQuotationDetail?.DepartureInfant || 0}
                              </div>
                            </div>
                          </div>
                        </td>
                        {/* <td className="price">
                      {FlightQuotationDetail?.TotalCost}
                    </td> */}
                        <td className="price">
                          {formatIndianNumber(
                            +(
                              (FlightQuotationDetail?.DepartureAdult || 0) *
                              +(FlightQuotationDetail?.AdultsCost || 0)
                            ) +
                              +(
                                (FlightQuotationDetail?.DepartureChild || 0) *
                                +(FlightQuotationDetail?.ChildCost || 0)
                              ) +
                              +(
                                (FlightQuotationDetail?.DepartureInfant || 0) *
                                +(FlightQuotationDetail?.InfantCost || 0)
                              ) +
                              +(
                                (FlightQuotationDetail?.DepartureAdult || 0) *
                                +(FlightQuotationDetail?.AdultsMarkup || 0)
                              ) +
                              +(
                                (FlightQuotationDetail?.DepartureChild || 0) *
                                +(FlightQuotationDetail?.ChildMarkup || 0)
                              ) +
                              +(
                                (FlightQuotationDetail?.DepartureInfant || 0) *
                                +(FlightQuotationDetail?.InfantMarkup || 0)
                              ),
                          )}
                        </td>
                      </tr>
                      {/* <tr>
                    <td>
                      Markup ({FlightQuotationDetail?.FromAirportCode} →{" "}
                      {FlightQuotationDetail?.ToAirportCode})
                    </td>
                    <td>{FlightQuotationDetail?.TotalDeparturePax}</td>
                    <td className="price">
                      {FlightQuotationDetail?.TotalMarkup}
                    </td>
                    <td className="price">
                      {+(
                        (FlightQuotationDetail?.DepartureAdult || 0) *
                        +(FlightQuotationDetail?.AdultsMarkup || 0)
                      ) +
                        +(
                          (FlightQuotationDetail?.DepartureChild || 0) *
                          +(FlightQuotationDetail?.ChildMarkup || 0)
                        ) +
                        +(
                          (FlightQuotationDetail?.DepartureInfant || 0) *
                          +(FlightQuotationDetail?.InfantMarkup || 0)
                        )}
                    </td>
                  </tr> */}
                      {FlightQuotationDetail?.TripType === "Two Way" && (
                        <>
                          <tr>
                            <td>
                              Base Fare (
                              {FlightQuotationDetail?.ReturnFromAirportCode} →{" "}
                              {FlightQuotationDetail?.ReturnToAirportCode})
                            </td>
                            <td>
                              <div className="d-flex gap-2 justify-content-between">
                                <div>
                                  {FlightQuotationDetail?.TotalReturnPax}
                                </div>
                                <div className="d-flex gap-1">
                                  <div>
                                    A -{" "}
                                    {FlightQuotationDetail?.ReturnAdult || 0}
                                  </div>{" "}
                                  |
                                  <div>
                                    C -{" "}
                                    {FlightQuotationDetail?.ReturnChild || 0}
                                  </div>{" "}
                                  |
                                  <div>
                                    I -{" "}
                                    {FlightQuotationDetail?.ReturnInfant || 0}
                                  </div>
                                </div>
                              </div>
                            </td>

                            {/* <td className="price">
                          {FlightQuotationDetail?.TotalReturnCost}
                        </td> */}
                            <td className="price">
                              {formatIndianNumber(
                                +(
                                  (FlightQuotationDetail?.ReturnAdult || 0) *
                                  +(
                                    FlightQuotationDetail?.ReturnAdultsCost || 0
                                  )
                                ) +
                                  +(
                                    (FlightQuotationDetail?.ReturnChild || 0) *
                                    +(
                                      FlightQuotationDetail?.ReturnChildCost ||
                                      0
                                    )
                                  ) +
                                  +(
                                    (FlightQuotationDetail?.ReturnInfant || 0) *
                                    +(
                                      FlightQuotationDetail?.ReturnInfantCost ||
                                      0
                                    )
                                  ) +
                                  +(
                                    (FlightQuotationDetail?.ReturnAdult || 0) *
                                    +(
                                      FlightQuotationDetail?.ReturnAdultsMarkup ||
                                      0
                                    )
                                  ) +
                                  +(
                                    (FlightQuotationDetail?.ReturnChild || 0) *
                                    +(
                                      FlightQuotationDetail?.ReturnChildMarkup ||
                                      0
                                    )
                                  ) +
                                  +(
                                    (FlightQuotationDetail?.ReturnInfant || 0) *
                                    +(
                                      FlightQuotationDetail?.ReturnInfantMarkup ||
                                      0
                                    )
                                  ),
                              )}
                            </td>
                          </tr>
                          {/* <tr>
                        <td>
                          Markup ({FlightQuotationDetail?.ReturnFromAirportCode}{" "}
                          → {FlightQuotationDetail?.ReturnToAirportCode})
                        </td>
                        <td>{FlightQuotationDetail?.TotalReturnPax}</td>
                        <td className="price">
                          {FlightQuotationDetail?.TotalReturnMarkup}
                        </td>
                        <td className="price">
                          {+(
                            (FlightQuotationDetail?.ReturnAdult || 0) *
                            +(FlightQuotationDetail?.ReturnAdultsMarkup || 0)
                          ) +
                            +(
                              (FlightQuotationDetail?.ReturnChild || 0) *
                              +(FlightQuotationDetail?.ReturnChildMarkup || 0)
                            ) +
                            +(
                              (FlightQuotationDetail?.ReturnInfant || 0) *
                              +(FlightQuotationDetail?.ReturnInfantMarkup || 0)
                            )}
                        </td>
                      </tr> */}
                        </>
                      )}
                    </tbody>
                  </table>

                  <div className="total-section">
                    <div className="total-row subtotal">
                      <span>Subtotal:</span>
                      <span className="price">
                        {formatIndianNumber(
                          FlightQuotationDetail?.MainGrandTotal || 0,
                        )}
                      </span>
                    </div>
                    <div className="total-row">
                      <span>
                        GST
                        {FlightQuotationDetail?.GSTPer
                          ? `@ ${FlightQuotationDetail?.GSTPer}%`
                          : ""}{" "}
                        (on Service Charges):
                      </span>
                      <span className="price">
                        {formatIndianNumber(
                          FlightQuotationDetail?.GSTAmount || 0,
                        )}
                      </span>
                    </div>
                    {FlightQuotationDetail?.TCSAmount &&
                      FlightQuotationDetail?.TCSAmount > 0 && (
                        <div className="total-row">
                          <span>
                            TCS{" "}
                            {FlightQuotationDetail?.TCSPer
                              ? `@ ${FlightQuotationDetail?.TCSPer}%`
                              : ""}
                            :
                          </span>
                          <span className="price">
                            {formatIndianNumber(
                              FlightQuotationDetail?.TCSAmount || 0,
                            )}
                          </span>
                        </div>
                      )}
                    <div className="total-row final">
                      <span>Total Amount:</span>
                      <span className="price">
                        {formatIndianNumber(
                          +(FlightQuotationDetail?.MainGrandTotal || 0) +
                            +(FlightQuotationDetail?.GSTAmount || 0) +
                            +(FlightQuotationDetail?.TCSAmount || 0),
                        )}
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: FlightQuotationDetail?.TextBaseDescription,
                  }}
                />
              )}
            </div>

            <div className="tax-info">
              <h4>
                <IconComponent icon={FcSurvey} /> Tax Information
              </h4>
              <p>
                <strong>GST:</strong> 5% GST is applicable on service charges as
                per Indian tax regulations.
              </p>
              <p>
                <strong>TCS:</strong> Tax Collected at Source (TCS) @ 5% is
                applicable on overseas tour packages exceeding ₹7,00,000 per
                financial year under Section 206C(1G) of Income Tax Act.
              </p>
              <p>
                <strong>Note:</strong> All prices are in Indian Rupees (INR).
                International flights may have additional taxes based on
                destination country regulations.
              </p>
            </div>

            {FlightQuotationDetail?.FlightScope === 2 &&
              FlightQuotationDetail?.FareRules && (
                <div className="terms-section">
                  <h4>Terms & Conditions</h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: FlightQuotationDetail?.FareRules,
                    }}
                  />
                  {/* <ul className="terms-list">
            <li>This quote is valid for 7 days from the date of issue</li>
            <li>
              Prices are subject to availability and may change without notice
            </li>
            <li>Full payment required at the time of booking confirmation</li>
            <li>Cancellation charges as per airline policy will apply</li>
            <li>Date change charges may apply as per airline terms</li>
            <li>
              Travel insurance is recommended and available at additional cost
            </li>
            <li>
              Valid passport required for all passengers (minimum 6 months
              validity)
            </li>
            <li>
              Visa requirements to be checked separately for international
              travel
            </li>
            <li>
              Check-in closes 2 hours before domestic and 3 hours before
              international flights
            </li>
          </ul> */}
                </div>
              )}

            <div className="action-buttons printbuttons">
              <button
                className="btn btn-primary"
                onClick={() => window.print()}
              >
                <IconComponent icon={MdPrint} className="fs-5" /> Print Quote
              </button>
              <button
                className="btn btn-success"
                onClick={() =>
                  handleSendEmail(
                    FlightQuotationDetail?.FlightQuot_GUID
                      ? FlightQuotationDetail?.FlightQuot_GUID
                      : "",
                  )
                }
              >
                <IconComponent icon={MdOutgoingMail} className="fs-5" /> Send
                Email
              </button>
              <button
                className="btn btn-secondary"
                onClick={() =>
                  handleQuotationDownload(
                    FlightQuotationDetail?.FlightQuot_GUID
                      ? FlightQuotationDetail?.FlightQuot_GUID
                      : "",
                  )
                }
              >
                <IconComponent icon={FaFilePdf} className="fs-6" /> Download PDF
              </button>
            </div>
          </div>

          <div className="footer">
            <p>
              Thank you for choosing{" "}
              {FlightQuotationDetail?.CompanyDetails &&
              FlightQuotationDetail?.CompanyDetails?.CompanyName
                ? FlightQuotationDetail?.CompanyDetails?.CompanyName
                : "AICRM Travel"}{" "}
              for your flight booking needs!
            </p>
            <p style={{ marginTop: "10px", fontSize: "14px", opacity: 0.9 }}>
              Quote generated on:{" "}
              {FlightQuotationDetail?.CreatedOn
                ? moment(FlightQuotationDetail?.CreatedOn).format("DD/MM/YYYY")
                : ""}{" "}
              {/* {FlightQuotationDetail?.CompanyDetails?.GSTNo &&
            `| GSTIN: ${FlightQuotationDetail?.CompanyDetails?.GSTNo}`} */}
            </p>
          </div>
        </div>
      ) : (
        <NoDataFoundPage />
      )}
    </>
  );
};

export default FlightQuotePrint;
